import _index from "./dist/index.js";
import _index2 from "./lib/index.js";
import _process from "process";
var exports = {};
var process = _process;

function isNodeLT(tar) {
  tar = (Array.isArray(tar) ? tar : tar.split(".")).map(Number);
  let i = 0,
      src = process.versions.node.split(".").map(Number);

  for (; i < tar.length; i++) {
    if (src[i] > tar[i]) return false;
    if (tar[i] > src[i]) return true;
  }

  return false;
}

exports = isNodeLT("8.6.0") ? _index : _index2;
export default exports;